import './SubscriptionTonkeeper.sass';

import React, { FC, useCallback } from 'react';

import { useTranslator } from '$hooks';
import { Button, Header, Placeholder } from '$uikit';
import { IcTonkeeper56 } from '$assets';
import { ModalLink } from '$shared/components';
import { useRoute, useRouter } from 'react-router5';

export const SubscriptionTonkeeper: FC = () => {
  const t = useTranslator();
  // const { hasSubscription } = useSelector(mainSelector);
  const {
    route: { params },
  } = useRoute();
  const invoiceUrl = params.invoiceUrl;
  const router = useRouter();
  //
  // const handleBack = useCallback(() => {
  //   goBack();
  // }, []);

  function renderContent() {
    // if (hasSubscription) {
    //   return (
    //     <Placeholder
    //       centered
    //       title={t('subscription_success_title')}
    //       icon={<IcSuccess72 />}
    //       actions={
    //         <Button onClick={handleBack} size="small">
    //           {t('back')}
    //         </Button>
    //       }
    //     >
    //       {t('subscription_success_caption')}
    //     </Placeholder>
    //   );
    // }

    return (
      <div className="SubscriptionTonkeeper">
        <Placeholder
          centered
          title={t('subscription_link_generated_title')}
          icon={<IcTonkeeper56 />}
          iconSize={120}
        >
          {t('subscription_link_generated')}
        </Placeholder>
        <div className="SubscriptionTonkeeper__buttons">
          <Button href={invoiceUrl} target="_blank">
            {t('subscription_link_generated_button')}
          </Button>
          <ModalLink name="top_up">
            <Button mode="secondary" style={{ marginTop: 12 }}>
              {t('subscription_how_get_tons')}
            </Button>
          </ModalLink>
        </div>
      </div>
    );
  }

  return (
    <>
      <Header showBackButton>Tonkeeper</Header>
      {renderContent()}
    </>
  );
};
